var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('h1',{staticClass:"text-center pt-4 pb-4"},[_vm._v(_vm._s(_vm.$t("title.groupManagement")))]),_c('GroupAssociateBuildingToTeam')],1)}
var staticRenderFns = []

export { render, staticRenderFns }